import { storeInstance } from './../../store.js';
import * as types from '../NGUD/types';
import Message from '@/components/shared/mixins/Message.js';
const state = {
  indices: [],
  indiceCiudad: []
};

const getters = {
  [types.ALL_INDICES]: state => {
    return state.indices;
  },
  [types.INDICE_CIUDAD]: () => {
    return storeInstance.state.NGUD.CiudadSelected !== null ? storeInstance.state.NGUD.CiudadSelected.indices : [];
  }
};

const mutations = {
  [types.MUTATE_ALL_INDICES]: (state, payload) => {
    state.indices = payload;
  },
  [types.MUTATE_INDICE_CIUDAD]: (state, payload) => {
    state.indiceCiudad = payload;
  }

};

const actions = {
  [types.ACTION_GET_ALL_INDICES]: ({ commit }) => {
    let request = { controller: '/Indice' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          commit(types.MUTATE_ALL_INDICES, response.data);
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  }
};

export default {
  actions,
  state,
  getters,
  mutations
};
